import Index from '@/views/common/Index'
import VenuePlan from '@/views/exhibition/venue/plan/Plan'
import VenuePlanEN from '@/views/exhibition/venue/plan/PlanEN'
import PositionAnon from '@/views/exhibition/booth/anon/PositionAnon'
import ExhpredictionEdit from '@/views/exhibition/prediction/exhprediction/ExhpredictionEdit'
import ExhpredictionEdit2 from '@/views/exhibition/prediction/exhprediction/ExhpredictionEdit2'
import Product from '@/views/exhibition/prediction/exhibitor/Product'
import Confirm from '@/views/exhibition/prediction/exhibitor/Confirm'
import ExhpredictionConfirm from '@/views/exhibition/prediction/exhprediction/ExhpredictionConfirm'
import ExhpredictionEditEN from '@/views/exhibition/prediction/exhprediction/ExhpredictionEdit_ENG'
import Select from '@/views/exhibition/booth/select/Select'
//付款管理
import Payment from '@/views/financial/payment/Payment'
import MessageboardZS from '@/views/messageboard/Messageboard' 
import BootTypeChangeZS from '@/views/bootTypeChange/BootTypeChange'
import PublicationZS from '@/views/publication/Publication'
import ConfirmationZS from '@/views/exhibitorsUpload/Confirmation'
// 参展人员
import ParticipantsBaseinfo from '@/views/exhibition/prediction/participants/Baseinfo'
import Number from '@/views/exhibition/prediction/number/Baseinfo'
//home
import HomeZS from '@/views/exhibition/home/Home_ZS'



export default [
  //----------展馆平面图无登录查看----------
  {
    path: '/plan/planAnon',
    meta: {auth: true, title: "展馆平面图"},
    component: VenuePlan,
    children: [
      {
        path: '/',
        name: 'planAnon',
        component: resolve => require(['@/views/exhibition/venue/plan/Plan'], resolve),
      },
    ]
  },
  //----------展馆平面图英文无登录查看----------
  {
    path: '/plan/planAnonEN',
    meta: {auth: true, title: "展馆平面图"},
    component: VenuePlanEN,
    children: [
      {
        path: '/',
        name: 'planAnonEN',
        component: resolve => require(['@/views/exhibition/venue/plan/PlanEN'], resolve),
      },
    ]
  },
  //----------展位无登录查看----------
  {
    path: '/booth/anon',
    meta: {auth: true, title: "展位选择"},
    component: PositionAnon,
    children: [
      {
        path: '/',
        name: 'positionAnon',
        component: resolve => require(['@/views/exhibition/booth/anon/PositionAnon'], resolve)
      },
    ]
  },
  

  //-------------------------------------------------------中文展商端--------------------------------------------------
  {
    path: '/exhibitorWeb',
    name: 'exhibitorWeb',
    redirect: 'exhibitor/home',
    meta: {auth: true},
    component: Index,
    children: [
      //--------------展商端home----------------
      {
        path: '/exhibitor/home',
        meta: {auth: true, title: "首页"},
        component: HomeZS,
        children: [
          {
            path: '/',
            name: 'exhibitor/home',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/home/Home_ZS'], resolve)
          },
        ]
      },
      //--------------展商端报名----------------
      {
        path: '/exhprediction',
        meta: {auth: true, title: "展会报名"},
        component: ExhpredictionEdit,
        children: [
          {
            path: '/',
            name: 'exhpredictionEdit',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit'], resolve)
          },
        ]
      },
      
      //----------展商报名-信息确认----------
      {
        path: '/exhprediction/confirm',
        meta: {auth: true, title: "报名信息确认"},
        component: ExhpredictionConfirm,
        children: [
          {
            path: '/',
            name: 'exhpredictionConfirm',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionConfirm'], resolve)
          },
        ]
      },
      //----------展商报名-报名信息修改----------
      {
        path: '/exhprediction/confirmEdit',
        meta: {auth: true, title: "报名信息修改"},
        component: ExhpredictionEdit2,
        children: [
          {
            path: '/',
            name: 'exhprediction/confirmEdit',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit2'], resolve)
          },
        ]
      },
      //----------展馆管理-展位选择----------
      {
        path: '/exhibitor/booth/select',
        meta: {auth: true, title: "展位选择"},
        component: Select,
        children: [
          // ------------倒计时---------
          {
            path: '/',
            name: 'exhibitor/booth/select/countdown',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/select/Countdown'], resolve)
          },
          // ------------展馆平面图---------
          {
            path: '/exhibitor/booth/select/plan',
            name: 'exhibitor/booth/select/plan',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/venue/plan/SelectedPlan'], resolve),
          },
          // ------------展位选择---------
          {
            path: '/exhibitor/booth/select/position',
            name: 'exhibitor/booth/select/position',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/select/PositionSelect'], resolve)
          },
        ]
      },
      //----------展商端-产品介绍---------
      {
        path: '/exhibitor/product',
        meta: {auth: true, title: "产品介绍"},
        component: Product,
        children: [
          {
            path: '/',
            name: 'exhibitorProduct',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhibitor/ProductList'], resolve)
          },
        ]
      },
      //----------展商端-信息确认---------
      {
        path: '/exhibitor/confirm',
        meta: {auth: true, title: "信息确认"},
        component: Confirm,
        children: [
          {
            path: '/',
            name: 'exhibitorConfirm',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhibitor/ConfirmList'], resolve)
          },
        ]
      },
      //----------展商端-付款管理---------
      {
        path: '/financial/paymentZS',
        meta: {auth: true, title: "展商付款管理"},
        component: Payment,
        children: [
          {
            path: '/',
            name: 'financial/paymentZS',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/financial/payment/PaymentZS'], resolve)
          }
        ]
      },
      //----------展位选择情况----------
      {
        path: '/booth/anon/selection',
        meta: {auth: true, title: "展位选择情况"},
        component: Select,
        children: [
          {
            path: '/',
            name: 'booth/selection',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/anon/PositionAnon'], resolve)
          },
        ]
      },
      //----------留言板----------
      {
        path: '/messageboardZS',
        meta: {auth: true, title: "信息通知", isRedirect: true},
        component: MessageboardZS,
        children: [
          {
            path: '/',
            name: 'messageboardZS',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/messageboard/MessageboardZS.vue'], resolve)
          }
        ]
      },
      //----------标改特----------
      {
        path: '/bootTypeChangeZS',
        meta: {auth: true, title: "标改特申请", isRedirect: true},
        component: BootTypeChangeZS,
        children: [
          {
            path: '/',
            name: 'bootTypeChangeZS',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/bootTypeChange/bootTypeChangeZS.vue'], resolve)
          }
        ]
      },
      //----------会刊----------
      {
        path: '/publicationZS',
        meta: {auth: true, title: "会刊", isRedirect: true},
        component: PublicationZS,
        children: [
          {
            path: '/',
            name: 'publicationZS',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/publication/PublicationZS.vue'], resolve)
          }
        ]
      },
      //----------报到资料下载----------
      {
        path: '/downloadingZS',
        meta: {auth: true, title: "报到资料下载", isRedirect: true},
        component: ConfirmationZS,
        children: [
          {
            path: '/',
            name: 'downloadingZS',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibitorsUpload/ConfirmationZS'], resolve)
          }
        ]
      },
    ]
  },


  //-------------------------------------------------------英文展商端--------------------------------------------------
  {
    path: '/exhibitorWebEN',
    name: 'exhibitorWebEN',
    redirect: 'exhibitor/homeEN',
    meta: {auth: true},
    component: Index,
    children: [
      //--------------展商端home----------------
      {
        path: '/exhibitor/homeEN',
        meta: {auth: true, title: "Home"},
        component: HomeZS,
        children: [
          {
            path: '/',
            name: 'exhibitor/homeEN',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/home/Home_ZS'], resolve)
          },
        ]
      },
      
      //------------------展商端报名英文-----------
      {
        path: '/exhpredictionEN',
        meta: {auth: true, title: "Exhibition Registration"},
        component: ExhpredictionEditEN,
        children: [
          {
            path: '/',
            name: 'exhpredictionEdit_ENG',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit_ENG'], resolve)
          },
          
        ]
      },
      //----------展商报名-信息确认----------
      {
        path: '/exhprediction/confirmEN',
        meta: {auth: true, title: "Exhibition Confirm"},
        component: ExhpredictionConfirm,
        children: [
          {
            path: '/',
            name: 'exhpredictionConfirm_ENG',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionConfirm'], resolve)
          },
        ]
      },
      //----------英文-展商端-展位选择----------
      {
        path: '/exhibitor/booth/selectEN',
        meta: {auth: true, title: "Booth Selection"},
        component: Select,
        children: [
          // ------------倒计时---------
          {
            path: '/',
            name: 'exhibitor/booth/select/countdownEN',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/select/Countdown'], resolve)
          },
          // ------------展馆平面图---------
          {
            path: '/exhibitor/booth/select/planEN',
            name: 'exhibitor/booth/select/planEN',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/venue/plan/SelectedPlanEN'], resolve)
          },
          // ------------展位选择---------
          {
            path: '/exhibitor/booth/select/positionEN',
            name: 'exhibitor/booth/select/positionEN',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/select/PositionSelect'], resolve)
          },
        ]
      },
      //----------英文-展商端-产品介绍---------
      {
        path: '/exhibitor/productEN',
        meta: {auth: true, title: "Product Introduction"},
        component: Product,
        children: [
          {
            path: '/',
            name: 'exhibitorProductEN',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhibitor/ProductList'], resolve)
          },
        ]
      },
      
      //----------英文-展商端-信息确认---------
      {
        path: '/exhibitor/confirmEN',
        meta: {auth: true, title: "Verify Message"},
        component: Confirm,
        children: [
          {
            path: '/',
            name: 'exhibitorConfirmEN',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhibitor/ConfirmList'], resolve)
          },
        ]
      },
      //----------展商端-付款管理---------
      {
        path: '/financial/paymentZSENG',
        meta: {auth: true, title: "Payment"},
        component: Payment,
        children: [
          {
            path: '/',
            name: 'financial/paymentZSENG',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/financial/payment/PaymentZS'], resolve)
          }
        ]
      },
      // 展商合同管理
      {
        path: '/contract/manage/ManageZSENG',
        name: 'ManageZS',
        meta: {auth: true, title: "Contract"},
        meta: {keepAlive: false},
        component: resolve => require(['@/views/contract/manage/ManageZS'], resolve)
      },
      //----------会刊----------
      {
        path: '/publicationZSEng',
        meta: {auth: true, title: "Catalogue Info", isRedirect: true},
        component: PublicationZS,
        children: [
          {
            path: '/',
            name: 'publicationZSEng',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/publication/PublicationZS.vue'], resolve)
          }
        ]
      },
      //----------参展人员申报----------
      {
        path: '/exhibitorcard',
        meta: {auth: true, title: "Badge application", isRedirect: true},
        component: ParticipantsBaseinfo,
        children: [
          {
            path: '/',
            name: 'exhibitorcard',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/participants/BaseinfoEng'], resolve)
          }
        ]
      },
      //----------参展人员数量申报----------
      {
        path: '/BadgeAdjustment',
        meta: {auth: true, title: "Badge No. adjustment", isRedirect: true},
        component: Number,
        children: [
          {
            path: '/',
            name: 'BadgeAdjustment',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/number/BaseinfoListEng'], resolve)
          }
        ]
      },
      //----------报到资料下载----------
      {
        path: '/downloadingZSEng',
        meta: {auth: true, title: "Registration documents downloading", isRedirect: true},
        component: ConfirmationZS,
        children: [
          {
            path: '/',
            name: 'downloadingZSEng',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibitorsUpload/ConfirmationZS'], resolve)
          }
        ]
      },

    ]
  },

    
  
]


// WEBPACK FOOTER //
// ./src/router/exhibitor.js